// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "additionalServiceWrapper__button-klH9n";
export { _1 as "__esModule", _2 as "additionalServiceWrapper__button" }
export default { "__esModule": _1, "additionalServiceWrapper__button": _2 }
